import React from "react";
import './Badge.scss';

type BadgeProps = {
    children: React.ReactNode,
    className?: string,
    color?: 'primary'|'red'|'yellow'|'green'|'gray',
};

function Badge(props: BadgeProps) {

    return (
        <span className={`badge badge-${props.color ?? 'primary'} ${props.className}`}>{props.children}</span>
    );
}

export default Badge;
